import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE, timeout: 60000 });

export function setAuthToken(token) {
  if (token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    localStorage.setItem("admin_token", token);
  } else {
    delete api.defaults.headers.common["Authorization"];
    localStorage.removeItem("admin_token");
  }
}

const existing = localStorage.getItem("admin_token");
if (existing) setAuthToken(existing);

export async function track(event, session_id, props = {}) {
  try { await api.post("/analytics/track", { event, session_id, props }); } catch { /* ignore */ }
}
